document.addEventListener("DOMContentLoaded", () => {
  const sectionWrapper = document.getElementById("section-wrapper");
  const product_id = sectionWrapper.dataset.productId;
  const product_price = sectionWrapper.dataset.price;
  const sticky_button_show_all_time = sectionWrapper.dataset.stickyShowAllTime === 'true';

  let build_a_box_data = null;

  // KEENSLIDER FOR PRODUCT IMAGES
  function ThumbnailPlugin(main) {
    return (slider) => {
      function removeActive() {
        slider.slides.forEach((slide) => {
          slide.classList.remove("active");
        });
      }

      function addActive(idx) {
        slider.slides[idx].classList.add("active");
      }

      function addClickEvents() {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener("click", () => {
            main.moveToIdx(idx);
          });
        });
      }

      const leftButton = document.getElementById("keen-large-slider-left");
      const rightButton = document.getElementById("keen-large-slider-right");

      rightButton.addEventListener("click", () => {
        if (!slider.track.details.atEnd) {
          main.next();
        }
      });

      leftButton.addEventListener("click", () => {
        if (!slider.track.details.atStart) {
          main.prev();
        }
      });

      slider.on("created", () => {
        addActive(slider.track.details.rel);
        addClickEvents();
        main.on("animationStarted", (main) => {
          removeActive();
          const next = main.animator.targetIdx || 0;
          addActive(main.track.absToRel(next));
          slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
        });
      });
    };
  }

  const product_large_slider = new KeenSlider("#product-keen-large-slider", {
    loop: false,
    slides: {
      spacing: 0,
      perView: 1,
    },
  });

  const product_thumbnails_slider = new KeenSlider(
    "#product-keen-thumbnail-slider",
    {
      loop: false,
      slides: {
        spacing: 10,
        perView: 6,
      },
      vertical: false,
      created: () => {
        const slides = sectionWrapper.querySelectorAll(".keen-slider__slide");
        slides.forEach((slide) => {
          slide.classList.remove("hidden");
        });
      },
    },
    [ThumbnailPlugin(product_large_slider)]
  );

  // GUARANTEE POPUP BLOCK (ON PRODUCT PAGE)
  const guarantee_popup_open_button = document.getElementById("block-guarantee-popup-open-button");
  const guarantee_popup_wrapper = document.getElementById("block-guarantee-popup-wrapper");
  const guarantee_popup_close_button = document.getElementById("block-guarantee-popup-close-button");

  if (guarantee_popup_open_button && guarantee_popup_wrapper) {
    guarantee_popup_open_button.addEventListener("click", () => {
      guarantee_popup_wrapper.classList.remove("hidden");
    });
  }

  if (guarantee_popup_close_button && guarantee_popup_wrapper) {
    guarantee_popup_close_button.addEventListener("click", () => {
      guarantee_popup_wrapper.classList.add("hidden");
    });
  }

  // COLOR PICKER SLIDER
  (function () {
    const el = document.querySelector(".color-list-slider-wrapper");
    if (!el) return;

    const bar = document.querySelector(".color-list-scrollbar");
    const track = bar.querySelector(".track");
    const thumb = bar.querySelector(".thumb");

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;

    let velocity = 0;
    let lastX = 0;
    let lastTime = 0;
    let rafId = 0;
    let momentumRunning = false;

    const stopMomentum = () => {
      momentumRunning = false;
      cancelAnimationFrame(rafId);
    };

    const momentum = () => {
      momentumRunning = true;

      if (Math.abs(velocity) < 0.01) {
        momentumRunning = false;
        return;
      }
      el.scrollLeft -= velocity * 12;
      velocity *= 0.95;

      updateThumb();
      rafId = requestAnimationFrame(momentum);
    };

    el.addEventListener("dragstart", (e) => e.preventDefault());

    el.addEventListener("mousedown", (e) => {
      if (e.button !== 0) return;
      isDown = true;
      el.classList.add("grabbing");

      bar.classList.add("active");

      startX = e.clientX;
      startScrollLeft = el.scrollLeft;
      velocity = 0;
      lastX = e.clientX;
      lastTime = Date.now();
      stopMomentum();
    });

    window.addEventListener(
      "mousemove",
      (e) => {
        if (!isDown) return;
        e.preventDefault();
        const dx = e.clientX - startX;
        el.scrollLeft = startScrollLeft - dx;

        const now = Date.now();
        const dt = now - lastTime;
        if (dt > 0) velocity = (e.clientX - lastX) / dt;
        lastX = e.clientX;
        lastTime = now;

        updateThumb();
      },
      { passive: false }
    );

    const endDrag = () => {
      if (!isDown) return;
      isDown = false;
      el.classList.remove("grabbing");

      setTimeout(() => bar.classList.remove("active"), 120);

      if (Math.abs(velocity) > 0.08) momentum();
    };

    window.addEventListener("mouseup", endDrag);
    el.addEventListener("mouseleave", endDrag);

    function updateThumb() {
      const cw = el.clientWidth;
      const sw = el.scrollWidth;
      const sl = el.scrollLeft;

      if (sw <= cw) {
        thumb.style.width = "0px";
        thumb.style.transform = "translateX(0)";
        return;
      }

      const trackW = track.clientWidth;
      const minThumb = 40;
      const thumbW = Math.max((cw / sw) * trackW, minThumb);
      const maxLeft = trackW - thumbW;
      const left = (sl / (sw - cw)) * maxLeft;

      thumb.style.width = thumbW + "px";
      thumb.style.transform = `translateX(${left}px)`;
    }

    function syncBarWidth() {
      //const rect = el.getBoundingClientRect();
      //bar.style.width = rect.width + 'px';
      updateThumb();
    }

    el.addEventListener(
      "scroll",
      () => {
        updateThumb();
      },
      { passive: true }
    );

    window.addEventListener("resize", syncBarWidth);

    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(() => syncBarWidth());
      ro.observe(el);
      ro.observe(track);
    } else {
      setTimeout(syncBarWidth, 60);
    }

    syncBarWidth();
    setTimeout(syncBarWidth, 250);
  })();

  // CUSTOM STICKY ATC BUTTON
  const stickyButtonWrapper = document.querySelector('.byteex-stycky-atc-button-wrapper');
  const stickyButton = document.getElementById('byteex-stycky-atc-button');
  const stickyButtonText = document.getElementById('sticky_atc_button_text');
  const nail_picker = document.getElementById('nail_picker');
  const submitButton = document.getElementById('pick-your-colors-button');

  if (stickyButtonWrapper && stickyButtonText && submitButton) {
    const scrollToElement = (el, offset = 0) => {
      const targetY = el.getBoundingClientRect().top + window.scrollY - offset;
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      } else {
        window.scrollTo(0, targetY);
      }
    };

    stickyButtonWrapper.addEventListener('click', () => {
      scrollToElement(nail_picker, 200);
    });

    const checkButtonPosition = () => {
      const currentSubmitButton = document.getElementById('pick-your-colors-button');
      const buttonRect = currentSubmitButton.getBoundingClientRect();
      if (buttonRect.bottom <= 70) {
        stickyButtonWrapper.style.transform = 'translateY(0px)';
      } else {
        stickyButtonWrapper.style.transform = 'translateY(140px)';
      }
    };

    if (!sticky_button_show_all_time) {
      window.addEventListener('scroll', checkButtonPosition);
    }    

    stickyButton.addEventListener('click', (event) => {
      event.stopPropagation();
      const stickyLoader = document.getElementById('sticky_atc_button_loader');
      const loaderDisplayStyle = window.getComputedStyle(stickyLoader).display;
      const currentSubmitButton = document.getElementById('pick-your-colors-button');

      scrollToElement(nail_picker, 300);

      if (currentSubmitButton.getAttribute('type') === 'submit' && loaderDisplayStyle === 'none') {
        currentSubmitButton.click();
      }      
    });
  }

  // TWO VIDEO BLOCK
  const two_video_block_button_1 = document.getElementById("two-video-block-button-1");
  const two_video_block_button_2 = document.getElementById("two-video-block-button-2");
  const two_video_block_video_1 = document.getElementById("two-video-block-video-1");
  const two_video_block_video_2 = document.getElementById("two-video-block-video-2");

  if (two_video_block_button_1 && two_video_block_button_2 && two_video_block_video_1 && two_video_block_video_2) {
    two_video_block_button_1.addEventListener("click", () => {
      two_video_block_video_1.classList.remove("hidden");
      two_video_block_video_2.classList.add("hidden");
      two_video_block_button_1.style.borderBottom = "thin solid #211912";
      two_video_block_button_2.style.borderBottom = "none";
    });

    two_video_block_button_2.addEventListener("click", () => {
      two_video_block_video_1.classList.add("hidden");
      two_video_block_video_2.classList.remove("hidden");
      two_video_block_button_1.style.borderBottom = "none";
      two_video_block_button_2.style.borderBottom = "thin solid #211912";
    });
  }

  fetch("https://api.skio.com/storefront-http/get-dynamic-box", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ productPlatformId: product_id }),
  })
    .then((response) => response.json())
    .then((data) => {
      build_a_box_data = data;
      //console.log('Build a box data ----------------------', build_a_box_data);

      let bab_percent_discount;
      for (const tier in build_a_box_data.DynamicBox.percentDiscountTier) {
        bab_percent_discount = build_a_box_data.DynamicBox.percentDiscountTier[tier];
      }

      const hidden_overlay = document.getElementById("hidden-overlay");
      const pick_your_colors_button = document.getElementById("pick-your-colors-button");
      const pick_your_colors_button_price = pick_your_colors_button.querySelector(".price");
      const pick_your_colors_button_compare_price = pick_your_colors_button.querySelector(".compare-price");

      const variant_picker_items_element = document.getElementById("variant-picker-items");
      const pre_selected_variant_number = parseInt(variant_picker_items_element.dataset.preSelectedVariantNumber);

      const variant_picker_items = document.querySelectorAll(".variant-picker-item");
      let max_number_of_wraps = 0;
      let min_number_of_wraps = 10;
      let current_number_of_wraps = 0;
      const build_a_box_id = build_a_box_data.DynamicBox.boxId;    

      const selling_plans_data = build_a_box_data.DynamicBox.sellingPlanGroup;
      const selling_plans_ids = Object.entries(selling_plans_data)
        .sort(([, a], [, b]) => a.position - b.position)
        .map(([key, value]) => ({
          id: key.split("/").pop(),
          discount: value.priceAdjustmentAmount,
          interval: value.interval,
          interval_count: value.intervalCount,
          title: value.title,
        }));

      let selected_selling_plan_id = selling_plans_ids[pre_selected_variant_number - 1].id;
      
      const color_items = document.querySelectorAll(".nail-picker-color");

      let selected_colors_array = [];

      const price_per_wrap_elements = document.querySelectorAll(".price-per-wrap");
      const variant_price_elements = document.querySelectorAll(".variant-price");
      const discount_percentage_elements = document.querySelectorAll(".discount-percentage");
      const price_block_loader_element = document.querySelector(".price-block-loader");
      const price_block_content_elements = document.querySelectorAll(".price-block-content");
      const price_block_elements = document.querySelectorAll(".price-block");    

      const nail_picker_title_wraps_number = document.getElementById("nail-picker-title-wraps-number");

      const nail_picker_selected_colors = document.querySelectorAll(".nail-picker-selected-color");
      const color_list_selected_colors = document.querySelectorAll(".color-list-selected-color");

      const selected_colors_sticky_atc = document.querySelectorAll('.byteex-stycky-atc-selected-color'); 

      const build_a_box_gift_items = document.querySelectorAll(".build-a-box-gift-item");

      const subscription_percent_element = document.getElementById("subscription-percent");
      const subscription_wraps_number_element = document.getElementById("subscription-wraps-number");
      const subscription_term_element = document.getElementById("subscription-term");
      const subscription_price_per_wrap_element = document.getElementById("subscription-price-per-wrap");
      const subscription_picker_first_item = document.querySelector(".subscription-picker-first-item");

      const nail_picker_last_step_popup = document.getElementById('nail-picker-last-step-popup');

      const nail_picker_color_list_wrapper = document.getElementById("nail-picker-color-list-wrapper");

      const nail_picker_color_list_close_popup = document.querySelectorAll(".nail-picker-color-list-close-popup");

      const selected_colors_last_step = document.querySelectorAll('.selected-colors-last-step');

      const upsells_selected_gifts = document.getElementById('upsells-selected-gifts');

      const upsells_collection_1 = document.getElementById('upsells-collection-1');
      const upsells_collection_2 = document.getElementById('upsells-collection-2');
      const upsells_collection_3 = document.getElementById('upsells-collection-3');

      // GET FREE COUNT FROM VARIANT TITLE
      function getFreeCount(str) {
        const match = str.match(/\+\s*(\d+)/);
        return match ? Number(match[1]) : null;
      }

      // get selected gifts count
      function getSelectedGiftsCount() {
        let selected_gifts = 0;

        build_a_box_gift_items.forEach((gift_item) => {
          const gift_item_image = gift_item.querySelector('img');
          if (!gift_item_image.classList.contains('hidden')) {
            selected_gifts++;
          }
        });

        return selected_gifts;
      }

      const variants_upgrade_data = {};

      // VARIANT PICKER ITEMS
      variant_picker_items.forEach((item, i, arr) => {
        const number_of_wraps = parseInt(item.dataset.numberOfWraps);
        const variant_title = item.dataset.title;

        // GET UPGRADE TEXT FOR VARIANT
        const upgrade_text = item.dataset.upgradeText || 'No upgrade text';
        if (number_of_wraps && upgrade_text) {
          variants_upgrade_data[number_of_wraps] = upgrade_text;
        }

        //const subscription_percent = selling_plans_ids[i].discount;
        const subscription_percent = bab_percent_discount;

        const per_set_price =
          Math.round(((product_price - (product_price * subscription_percent) / 100) / 100) * 100) / 100;

        price_per_wrap_elements[i].textContent = per_set_price;
        variant_price_elements[i].textContent = (per_set_price * number_of_wraps).toFixed(2);
        discount_percentage_elements[i].textContent = subscription_percent;

        // set the max number of wraps and the price per wrap
        if (number_of_wraps > max_number_of_wraps) {
          max_number_of_wraps = number_of_wraps;
          max_per_set = per_set_price;
        }

        // set the min number of wraps
        if (number_of_wraps < min_number_of_wraps) {
          min_number_of_wraps = number_of_wraps;
        }

        if (i === 0) {
          pick_your_colors_button_price.textContent = (per_set_price * number_of_wraps).toFixed(2);
          pick_your_colors_button_compare_price.textContent = ((product_price * number_of_wraps) / 100).toFixed(2);
        }

        // add event listener to the variant picker item
        item.addEventListener("click", () => {
          current_number_of_wraps = number_of_wraps;

          // set upsells collection for each variant
          if (i === 0) {
            upsells_collection_1.style.display = 'flex';
            upsells_collection_2.style.display = 'none';
            upsells_collection_3.style.display = 'none';
          }
          if (i === 1) {
            upsells_collection_1.style.display = 'none';
            upsells_collection_2.style.display = 'flex';
            upsells_collection_3.style.display = 'none';
          }
          if (i === 2) {
            upsells_collection_1.style.display = 'none';
            upsells_collection_2.style.display = 'none';
            upsells_collection_3.style.display = 'flex';
          }

          // update subscription percent, wraps number, term and price per wrap on subscription block
          subscription_percent_element.textContent = subscription_percent;
          subscription_wraps_number_element.textContent = current_number_of_wraps;        
          subscription_price_per_wrap_element.textContent = per_set_price;

          const interval_count = selling_plans_ids[i].interval_count;
          if (interval_count > 1) {
            subscription_term_element.textContent = `${interval_count} ${selling_plans_ids[i].interval}s`;
          } else {
            subscription_term_element.textContent = `${interval_count} ${selling_plans_ids[i].interval}`;
          }

          selected_selling_plan_id = selling_plans_ids[i].id;

          // set the wraps number in the selected colors title
          nail_picker_title_wraps_number.textContent = number_of_wraps;

          // get free count from variant title
          const freeCount = getFreeCount(variant_title);

          // update selected colors
          nail_picker_selected_colors.forEach((color, index) => {
            const lock_icon = color.querySelector(".lock-icon");
            const plus_icon = color.querySelector("span");
            const image = color.querySelector("img");
            const image_wrapper = color.firstElementChild;
            const remove_icon = color.querySelector(".remove-selected-color");
            const default_title = color.dataset.defaultTitle;
            const color_name = color.querySelector("p");

            if (index > number_of_wraps - 1) {
              lock_icon.classList.remove("hidden");
              plus_icon.classList.add("hidden");
              image.classList.add("hidden");
              image.removeAttribute("src");
              remove_icon.classList.add("hidden");
              color_name.textContent = default_title;
              color.removeAttribute("data-id");

              image_wrapper.style.backgroundColor = "#FAF7F5";
              image_wrapper.style.borderColor = "#2119124D";
            } else {
              lock_icon.classList.add("hidden");
              if (!image.src) {
                plus_icon.classList.remove("hidden");
              }

              image_wrapper.style.backgroundColor = "#ffffff";
              image_wrapper.style.borderColor = "#211912B2";
            }

            // ADD FREE LABEL TO MAIN SELECTED COLOR
            const free_label = color.querySelector('.nail-picker-selected-color-free-label');
            if (freeCount && index <= current_number_of_wraps - 1 && index >= current_number_of_wraps - freeCount) {
              free_label.style.display = 'block';
            } else {
              free_label.style.display = 'none';
            }
          });

          // update selected colors array
          selected_colors_array = [];
          nail_picker_selected_colors.forEach(color => {
            const id = color.dataset.id;

            if (id) {
              selected_colors_array.push(id);
            }
          });

          // update selected colors on picker on color items list
          color_items.forEach((color) => {
            const id = color.dataset.variantId;
            const color_item_count = color.querySelector(".color-item-count");

            if (selected_colors_array.includes(id)) {
              const color_count = checkSelectedColor(id);              
              color_item_count.textContent = color_count;
            } else {
              color.querySelector(".quantity-color-item-wrapper").classList.add("hidden");
              const current_color_img = color.querySelector('.nail-picker-color-image-wrapper');
              current_color_img.classList.remove('selected-color-item');
              color_item_count.textContent = 0;
            }
          });

          // update selected colors on picker
          color_list_selected_colors.forEach((color, index) => {
            const lock_icon = color.querySelector(".lock-icon");
            const plus_icon = color.querySelector("span");
            const image = color.querySelector("img");

            if (index > number_of_wraps - 1) {
              lock_icon.classList.remove("hidden");
              plus_icon.classList.add("hidden");
              image.classList.add("hidden");
              image.removeAttribute("src");
              color.removeAttribute("data-id");

              color.style.backgroundColor = "#FAF7F5";
              color.style.borderColor = "#2119124D";
            } else {
              lock_icon.classList.add("hidden");
              if (!image.src) {
                plus_icon.classList.remove("hidden");
              }

              color.style.backgroundColor = "#ffffff";
              color.style.borderColor = "#211912B2";
            }
          });

          // update selected colors on sticky atc
          selected_colors_sticky_atc.forEach((color, index) => {
            const lock_icon = color.querySelector(".lock-icon");
            const plus_icon = color.querySelector("span");
            const image = color.querySelector("img");

            if (index > number_of_wraps - 1) {
              lock_icon.classList.remove("hidden");
              plus_icon.classList.add("hidden");
              image.classList.add("hidden");
              image.removeAttribute("src");

              color.style.backgroundColor = "#FAF7F5";
              color.style.borderColor = "#2119124D";
            } else {
              lock_icon.classList.add("hidden");
              if (!image.src) {
                plus_icon.classList.remove("hidden");
              }

              color.style.backgroundColor = "#ffffff";
              color.style.borderColor = "#211912B2";
            }
          });

          // update selected colors on last step popup
          selected_colors_last_step.forEach((color, index) => {
            if (index > number_of_wraps - 1) {
              color.querySelector("img").classList.add("hidden");
              color.querySelector("img").removeAttribute("src");
              color.querySelector(".lock-icon").classList.remove("hidden");
              color.querySelector(".remove-selected-color-on-last-step").classList.add("hidden");
              color.removeAttribute("data-id");
              color.querySelector(".selected-last-step-upgrade").classList.remove("hidden");
            }
          });

          // set price for selected variant
          price_block_elements.forEach((element) => {
            element.style.display = "none";
          });
          price_block_elements[i].style.display = "block";

          // update price for selected variant on atc button
          pick_your_colors_button_price.textContent = (per_set_price * number_of_wraps).toFixed(2);
          pick_your_colors_button_compare_price.textContent = ((product_price * number_of_wraps) / 100).toFixed(2);

          // set active styles for selected variant
          arr.forEach(item => {
            item.classList.remove("active");
          });
          item.classList.add("active");

          // toggle atc button
          if (selected_colors_array.length === number_of_wraps) {
            nail_picker_last_step_popup.classList.remove('hidden');
          }

          // show/hide gift for selected variant
          build_a_box_gift_items.forEach((gift_item) => {
            const gift_wraps_number = parseInt(gift_item.dataset.wrapsNumber); // number of wraps for gift item
            const image = gift_item.querySelector("img");

            if (gift_wraps_number > current_number_of_wraps) {
              image.classList.add("hidden");
            } else {
              image.classList.remove("hidden");
            }
          });

          if (upsells_selected_gifts) {
            upsells_selected_gifts.textContent = getSelectedGiftsCount();
          }
        });
      });          

      // CLICK PRE SELECTED VARIANT
      variant_picker_items[pre_selected_variant_number - 1].click();
      subscription_picker_first_item.classList.remove("opacity-0");

      // SET UPGRADE TEXT FOR LAST STEP POPUP AND ADD CLICK EVENTS
      selected_colors_last_step.forEach((color, index) => {
        const data_keys = Object.keys(variants_upgrade_data);

        if (data_keys.length >= 2) {
          if (index >= data_keys[0] && index < data_keys[1] ) {
            color.querySelector(".selected-last-step-upgrade").textContent = variants_upgrade_data[data_keys[0]];
          }
          
          if (index >= data_keys[1]) {
            color.querySelector(".selected-last-step-upgrade").textContent = variants_upgrade_data[data_keys[1]];
          }

          color.addEventListener("click", () => {
            const upgrade_button = color.querySelector(".selected-last-step-upgrade");
            const button_text = upgrade_button.textContent;

            if (button_text.includes(variants_upgrade_data[data_keys[0]]) && !upgrade_button.classList.contains("hidden")) {
              variant_picker_items[1].click();
              nail_picker_last_step_popup.classList.add('hidden');
            }

            if (button_text.includes(variants_upgrade_data[data_keys[1]]) && !upgrade_button.classList.contains("hidden")) {
              variant_picker_items[0].click();
              nail_picker_last_step_popup.classList.add('hidden');
            }
          });
        }
      });

      // HIDE PRICE BLOCK LOADER AND SHOW PRICE BLOCK CONTENT
      price_block_loader_element.classList.add("hidden");
      price_block_content_elements.forEach((element) => {
        element.classList.remove("hidden");
        element.classList.add("flex");
      }); 

      // HIDE LOADER AND SHOW TEXT FOR PICK YOUR COLORS BUTTON
      pick_your_colors_button.querySelector(".loader").classList.add("hidden");
      pick_your_colors_button.querySelector(".text").classList.remove("hidden");

      // OPEN NAIL PICKER FROM SELECTED COLORS
      nail_picker_selected_colors.forEach((color) => {
        color.addEventListener("click", () => {
          hidden_overlay.classList.remove("hidden");
          document.body.style.overflow = "hidden";

          nail_picker_color_list_wrapper.classList.remove("hidden");

          if (selected_colors_array.length === current_number_of_wraps) {
            nail_picker_last_step_popup.classList.remove('hidden');
          } else {
            nail_picker_last_step_popup.classList.add('hidden');
          }
        });
      });

      // CLOSE NAIL PICKER
      nail_picker_color_list_close_popup.forEach((item) => {
        item.addEventListener("click", () => {
          hidden_overlay.classList.add("hidden");
          document.body.style.overflow = "auto";

          nail_picker_color_list_wrapper.classList.add("hidden");
        });
      });  

      // PICK YOUR COLORS BUTTON / ADD TO CART BUTTON  
      pick_your_colors_button.addEventListener("click", (e) => {
        hidden_overlay.classList.remove("hidden");
        document.body.style.overflow = "hidden";
        nail_picker_color_list_wrapper.classList.remove("hidden");
        
        if (selected_colors_array.length === current_number_of_wraps) {
          nail_picker_last_step_popup.classList.remove('hidden');
        } else {
          nail_picker_last_step_popup.classList.add('hidden');
        }                
      });   

      // NAIL PICKER PRODUCTS FROM BUILD A BOX DATA
      const selectable_product_variants = build_a_box_data.DynamicBox.selectableProductVariants;
      const productIds = selectable_product_variants.map((p) =>
        p.productPlatformId.replace("gid://shopify/Product/", "")
      );

      // HIDE PRODUCTS FROM COLLECTION THAT ARE NOT IN THE BUILD A BOX
      color_items.forEach((item) => {
        const сolor_id = item.dataset.id;

        if (!productIds.includes(сolor_id)) {
          item.classList.add("hidden");
        }
      });

      // COLOR POPUP ELEMENTS
      const nail_picker_color_open_popup = document.querySelectorAll('.nail-picker-color-open-popup');
      const nail_picker_color_close_popup = document.querySelectorAll('.nail-picker-color-close-popup');
      const nail_picker_color_popup_add_buttons = document.querySelectorAll('.nail-picker-color-popup-add-button'); 

      // SLIDER INIT FOR COLOR POPUP
      let slider = null;
      function sliderInit(elementId) {
        function sliderNavigation(slider) {
          let controlsWrapper, dots, arrowLeft, arrowRight;
        
          function removeElement(el) {
            el?.parentNode?.removeChild(el);
          }
        
          function createDiv(className) {
            const div = document.createElement("div");
            className.split(" ").forEach(name => div.classList.add(name));
            return div;
          }
        
          function controlsMarkup(remove) {
            if (remove) {
              removeElement(controlsWrapper);
              return;
            }
        
            controlsWrapper = createDiv("product-image-keen-slider-navigation-controls");
        
            arrowLeft = createDiv("product-image-keen-slider-arrow product-image-keen-slider-arrow--left");
            arrowRight = createDiv("product-image-keen-slider-arrow product-image-keen-slider-arrow--right");
        
            arrowLeft.innerHTML = " "; 
            arrowRight.innerHTML = " ";
        
            arrowLeft.addEventListener("click", () => slider.prev());
            arrowRight.addEventListener("click", () => slider.next());
        
            controlsWrapper.appendChild(arrowLeft);
            controlsWrapper.appendChild(arrowRight);
        
            dots = createDiv("product-image-keen-slider-dots");
            const totalSlides = slider.track.details.slides.length;
        
            for (let i = 0; i < totalSlides; i++) {
              const dot = createDiv("product-image-keen-slider-dot");
              dot.addEventListener("click", () => slider.moveToIdx(i));
              dots.appendChild(dot);
            }
        
            controlsWrapper.appendChild(dots);
            slider.container.parentNode.appendChild(controlsWrapper);
          }
        
          function updateClasses() {
            const rel = slider.track.details.rel;
        
            if (dots) {
              Array.from(dots.children).forEach((dot, idx) => {
                dot.classList.toggle("product-image-keen-slider-dot--active", idx === rel);
              });
            }
        
            if (arrowLeft && arrowRight) {
              const maxIdx = slider.track.details.slides.length - 1;
              arrowLeft.classList.toggle("disabled", rel === 0);
              arrowRight.classList.toggle("disabled", rel === maxIdx);
            }
          }
        
          slider.on("created", () => {
            controlsMarkup();
            updateClasses();
          });
        
          slider.on("slideChanged", updateClasses);
          slider.on("destroyed", () => controlsMarkup(true));
        }
        
        slider = new KeenSlider(
          elementId,
          {
            loop: false,
            slides: { perView: 1, spacing: 16 }
          },
          [sliderNavigation]
        );
      };

      // OPEN NAIL PICKER COLOR POPUP
      nail_picker_color_open_popup.forEach(item => {
        item.addEventListener('click', (event) => {
          event.stopPropagation();
          const current_color = event.currentTarget;
          const data_popup_id = current_color.dataset.popupId;

          const color_popup = document.getElementById(data_popup_id);
          if (color_popup) {
            color_popup.classList.remove('hidden');
            nail_picker_color_list_wrapper.style.overflowY = 'hidden';

            const slider_container = color_popup.querySelector('.keen-slider');

            if (slider_container) {
              sliderInit(slider_container);
            }
          }      
        });
      });

      // CLOSE NAIL PICKER COLOR POPUP
      nail_picker_color_close_popup.forEach(item => { 
        item.addEventListener('click', (event) => {
          event.stopPropagation();
          const current_color = event.currentTarget;
          const data_id = current_color.dataset.id;      

          if (slider) {
            slider.destroy();
            slider = null;
          }

          const choose_color_popup = document.getElementById(data_id);
          if (choose_color_popup) {
            choose_color_popup.classList.add('hidden');
            nail_picker_color_list_wrapper.style.overflowY = 'auto';
          }
        });
      });

      // CHECK SELECTED COLOR COUNT
      function checkSelectedColor(data_id) {
        return selected_colors_array.filter((id) => id === data_id).length;
      }

      function addProduct(data_id, data_title, data_image) {
        selected_colors_array.push(data_id);

        for (const color of nail_picker_selected_colors) {
          const image = color.querySelector("img");
          if (!image.src) {
            image.src = data_image;
            image.classList.remove("hidden");
            color.querySelector("p").textContent = data_title;
            color.querySelector("span").classList.add("hidden");
            color.querySelector(".remove-selected-color").classList.remove("hidden");
            color.setAttribute("data-id", data_id);

            break;
          }
        }

        for (const color of color_list_selected_colors) {
          const image = color.querySelector("img");
          if (!image.src) {
            image.src = data_image;
            image.classList.remove("hidden");
            color.querySelector("span").classList.add("hidden");
            color.setAttribute("data-id", data_id);

            break;
          }
        }

        for (const color of selected_colors_sticky_atc) {
          const image = color.querySelector("img");
          if (!image.src) {
            image.src = data_image;
            image.classList.remove("hidden");
            color.querySelector("span").classList.add("hidden");
            color.setAttribute("data-id", data_id);

            break;
          }
        }

        for (const color of selected_colors_last_step) {
          const image = color.querySelector("img");
          if (!image.src) {
            image.src = data_image;
            image.classList.remove("hidden");
            color.querySelector(".lock-icon").classList.add("hidden");
            color.querySelector(".remove-selected-color-on-last-step").classList.remove("hidden");
            color.querySelector(".selected-last-step-upgrade").classList.add("hidden");
            color.setAttribute("data-id", data_id);

            break;
          }
        }
      }

      // ADD COLOR TO PICKER FROM COLOR LIST
      color_items.forEach((color_item) => {
        const add_color_item_button = color_item.querySelector(".add-color-item-button");
        if (add_color_item_button) {
          add_color_item_button.addEventListener("click", () => {
            const current_color = color_item;
            const data_id = current_color.dataset.variantId;
            const data_title = current_color.dataset.title;
            const data_image = current_color.dataset.image;

            if (selected_colors_array.length < current_number_of_wraps) {
              current_color.querySelector(".quantity-color-item-wrapper").classList.remove("hidden");

              addProduct(data_id, data_title, data_image);

              const current_color_img = current_color.querySelector('.nail-picker-color-image-wrapper');
              current_color_img.classList.add('selected-color-item');

              const color_count = checkSelectedColor(data_id);
              const color_item_count = current_color.querySelector(".color-item-count");
              color_item_count.textContent = color_count;

              if (selected_colors_array.length === current_number_of_wraps) {
                nail_picker_last_step_popup.classList.remove('hidden');
              }
            }
          });
        }

        const add_color_item_button_plus = color_item.querySelector(".color-item-count-plus");
        if (add_color_item_button_plus) {
          add_color_item_button_plus.addEventListener("click", () => {
            const current_color = color_item;
            const data_id = current_color.dataset.variantId;
            const data_title = current_color.dataset.title;
            const data_image = current_color.dataset.image;

            if (selected_colors_array.length < current_number_of_wraps) {
              addProduct(data_id, data_title, data_image);

              const color_count = checkSelectedColor(data_id);
              const color_item_count = current_color.querySelector(".color-item-count");

              if (color_item_count) {
                color_item_count.textContent = color_count;
              }
            }

            if (selected_colors_array.length === current_number_of_wraps) {
              nail_picker_last_step_popup.classList.remove('hidden');
            }
          });
        }
      });

      // ADD COLOR TO PICKER FROM COLOR POPUP
      nail_picker_color_popup_add_buttons.forEach(item => {
        item.addEventListener('click', (event) => {
          const current_color = event.currentTarget;
          const data_id = current_color.dataset.id;
          const data_title = current_color.dataset.title;
          const data_image = current_color.dataset.image;
          const data_popup_id = current_color.dataset.popupId;

          if (selected_colors_array.length < current_number_of_wraps) {
            addProduct(data_id, data_title, data_image);

            const color_item = document.querySelector(`.nail-picker-color[data-variant-id="${data_id}"]`);
            color_item.querySelector(".quantity-color-item-wrapper").classList.remove("hidden");

            const color_count = checkSelectedColor(data_id);
            const color_item_count = color_item.querySelector(".color-item-count");
            color_item_count.textContent = color_count;

            if (selected_colors_array.length === current_number_of_wraps) {
              nail_picker_last_step_popup.classList.remove('hidden');
            }

            const current_color_img = color_item.querySelector('.nail-picker-color-image-wrapper');
            current_color_img.classList.add('selected-color-item');
          }
          
          const color_popup = document.getElementById(data_popup_id);
          color_popup.classList.add('hidden');

          if (slider) {
            slider.destroy();
            slider = null;
          }
        });
      }); 

      // REMOVE BUTTONS ON COLOR ITEMS LIST
      const remove_selected_color_items = document.querySelectorAll(".remove-selected-color-item");
      remove_selected_color_items.forEach((item) => {
        item.addEventListener("click", (event) => {
          event.stopPropagation();
          const current_item = event.currentTarget;
          const parent = current_item.closest(".nail-picker-color");
          const data_id = current_item.dataset.id;

          selected_colors_array.splice(selected_colors_array.indexOf(data_id), 1);

          if (checkSelectedColor(data_id) === 0) {
            parent.querySelector(".quantity-color-item-wrapper").classList.add("hidden");

            const current_color_img = parent.querySelector('.nail-picker-color-image-wrapper');
            current_color_img.classList.remove('selected-color-item');
          }

          const color_item_count = parent.querySelector(".color-item-count");
          const color_count = checkSelectedColor(data_id);
          color_item_count.textContent = color_count;

          const nail_picker_selected_colors_reversed = [...nail_picker_selected_colors].reverse();
          for (const color of nail_picker_selected_colors_reversed) {
            const id = color.dataset.id;
            const default_title = color.dataset.defaultTitle;

            if (id === data_id) {
              const image = color.querySelector("img");
              image.removeAttribute("src");
              image.classList.add("hidden");

              color.removeAttribute("data-id");

              color.querySelector("p").textContent = default_title;
              color.querySelector("span").classList.remove("hidden");
              color.querySelector(".remove-selected-color").classList.add("hidden");

              break;
            }
          }

          const color_list_selected_colors_reversed = [...color_list_selected_colors].reverse();
          for (const color of color_list_selected_colors_reversed) {
            const id = color.dataset.id;

            if (id === data_id) {
              const image = color.querySelector("img");
              image.removeAttribute("src");
              image.classList.add("hidden");

              color.removeAttribute("data-id");
              color.querySelector("span").classList.remove("hidden");

              break;
            }
          }

          const selected_colors_sticky_atc_reversed = [...selected_colors_sticky_atc].reverse();
          for (const color of selected_colors_sticky_atc_reversed) {
            const id = color.dataset.id;

            if (id === data_id) {
              const image = color.querySelector("img");
              image.removeAttribute("src");
              image.classList.add("hidden");

              color.removeAttribute("data-id");
              color.querySelector("span").classList.remove("hidden");

              break;
            }
          }

          const selected_colors_last_step_reversed = [...selected_colors_last_step].reverse();
          for (const color of selected_colors_last_step_reversed) {
            const id = color.dataset.id;

            if (id === data_id) {
              const image = color.querySelector("img");
              image.removeAttribute("src");
              image.classList.add("hidden");

              color.removeAttribute("data-id");
              color.querySelector(".lock-icon").classList.remove("hidden");
              color.querySelector(".remove-selected-color-on-last-step").classList.add("hidden");

              break;
            }
          }
        });
      });

      // REMOVER FROM SELECTED COLORS
      const remove_selected_colors = document.querySelectorAll(".remove-selected-color");
      remove_selected_colors.forEach((item, index) => {
        item.addEventListener("click", (event) => {
          event.stopPropagation();
          const current_item = event.currentTarget;
          const parent = current_item.closest(".nail-picker-selected-color");
          const data_id = parent.dataset.id;

          selected_colors_array.splice(selected_colors_array.indexOf(data_id), 1);          

          for (const color of color_items) {
            const id = color.dataset.variantId;

            if (id === data_id) {
              const color_count = checkSelectedColor(data_id);

              if (color_count === 0) {
                color.querySelector(".quantity-color-item-wrapper").classList.add("hidden");
                const current_color_img = color.querySelector('.nail-picker-color-image-wrapper');
                current_color_img.classList.remove('selected-color-item');
              }

              const color_item_count = color.querySelector(".color-item-count");
              color_item_count.textContent = color_count;

              break;
            }
          }

          const current_color_for_remove = nail_picker_selected_colors[index];
          const default_title = current_color_for_remove.dataset.defaultTitle;
          current_color_for_remove.removeAttribute("data-id");
          current_color_for_remove.querySelector("img").removeAttribute("src");
          current_color_for_remove.querySelector("img").classList.add("hidden");
          current_color_for_remove.querySelector("p").textContent = default_title;
          current_color_for_remove.querySelector("span").classList.remove("hidden");
          current_color_for_remove.querySelector(".remove-selected-color").classList.add("hidden");

          const current_picker_color_for_remove = color_list_selected_colors[index];
          current_picker_color_for_remove.removeAttribute("data-id");
          current_picker_color_for_remove.querySelector("img").removeAttribute("src");
          current_picker_color_for_remove.querySelector("img").classList.add("hidden");
          current_picker_color_for_remove.querySelector("span").classList.remove("hidden");

          const current_sticky_color_for_remove = selected_colors_sticky_atc[index];
          current_sticky_color_for_remove.removeAttribute("data-id");
          current_sticky_color_for_remove.querySelector("img").removeAttribute("src");
          current_sticky_color_for_remove.querySelector("img").classList.add("hidden");
          current_sticky_color_for_remove.querySelector("span").classList.remove("hidden");

          const current_last_step_color_for_remove = selected_colors_last_step[index];
          current_last_step_color_for_remove.removeAttribute("data-id");
          current_last_step_color_for_remove.querySelector("img").removeAttribute("src");
          current_last_step_color_for_remove.querySelector("img").classList.add("hidden");
          current_last_step_color_for_remove.querySelector(".lock-icon").classList.remove("hidden");
          current_last_step_color_for_remove.querySelector(".remove-selected-color-on-last-step").classList.add("hidden");
        });
      });   

      // REMOVER FROM SELECTED COLORS ON LAST STEP
      const remove_selected_colors_last_step = document.querySelectorAll(".remove-selected-color-on-last-step");
      remove_selected_colors_last_step.forEach((item, index) => {
        item.addEventListener("click", (event) => {
          const current_button = event.currentTarget;
          const parent = current_button.parentElement;
          const data_id = parent.dataset.id;

          selected_colors_array.splice(selected_colors_array.indexOf(data_id), 1);
          nail_picker_last_step_popup.classList.add('hidden');

          for (const color of color_items) {
            const id = color.dataset.variantId;
            console.log('id', id);

            if (id === data_id) {
              const color_count = checkSelectedColor(data_id);
              console.log('color_count', color_count);

              if (color_count === 0) {
                color.querySelector(".quantity-color-item-wrapper").classList.add("hidden");
                const current_color_img = color.querySelector('.nail-picker-color-image-wrapper');
                current_color_img.classList.remove('selected-color-item');
              }

              const color_item_count = color.querySelector(".color-item-count");
              color_item_count.textContent = color_count;

              break;
            }
          }

          parent.querySelector("img").classList.add("hidden");
          parent.querySelector("img").removeAttribute("src");
          parent.querySelector(".lock-icon").classList.remove("hidden");
          parent.querySelector(".remove-selected-color-on-last-step").classList.add("hidden");
          parent.removeAttribute("data-id");

          const current_color_for_remove = nail_picker_selected_colors[index];
          const default_title = current_color_for_remove.dataset.defaultTitle;
          current_color_for_remove.removeAttribute("data-id");
          current_color_for_remove.querySelector("img").removeAttribute("src");
          current_color_for_remove.querySelector("img").classList.add("hidden");
          current_color_for_remove.querySelector("p").textContent = default_title;
          current_color_for_remove.querySelector("span").classList.remove("hidden");
          current_color_for_remove.querySelector(".remove-selected-color").classList.add("hidden");

          const current_picker_color_for_remove = color_list_selected_colors[index];
          current_picker_color_for_remove.removeAttribute("data-id");
          current_picker_color_for_remove.querySelector("img").removeAttribute("src");
          current_picker_color_for_remove.querySelector("img").classList.add("hidden");
          current_picker_color_for_remove.querySelector("span").classList.remove("hidden");

          const current_sticky_color_for_remove = selected_colors_sticky_atc[index];
          current_sticky_color_for_remove.removeAttribute("data-id");
          current_sticky_color_for_remove.querySelector("img").removeAttribute("src");
          current_sticky_color_for_remove.querySelector("img").classList.add("hidden");
          current_sticky_color_for_remove.querySelector("span").classList.remove("hidden");
        });
      });   
      
      // LAST STEP POPUP CLOSE BUTTON
      const nail_picker_last_step_close_popup = document.querySelector(".nail-picker-last-step-close-popup");
      nail_picker_last_step_close_popup.addEventListener('click', () => {
        hidden_overlay.classList.add("hidden");
        document.body.style.overflow = "auto";
        nail_picker_last_step_popup.classList.add('hidden');
        nail_picker_color_list_wrapper.classList.add("hidden");
      });

      // LAST STEP POPUP ADD TO CART BUTTON
      const nail_picker_last_step_atc_button = document.querySelector('.nail-picker-last-step-atc-button');
      nail_picker_last_step_atc_button.addEventListener('click', () => {
        goToUpsells();       
      });

      // GUARANTEE POPUP ELEMENTS
      const guarantee_popup_open_button = document.getElementById("guarantee-popup-open-button");
      const guarantee_popup_content = document.getElementById("guarantee-popup-content");
      const guarantee_popup_close_buttons = document.querySelectorAll(".guarantee-popup-close-button");

      // OPEN GUARANTEE POPUP
      if (guarantee_popup_open_button && guarantee_popup_content) {
        guarantee_popup_open_button.addEventListener("click", () => {
          guarantee_popup_content.classList.remove("hidden");
        });
      }

      // CLOSE GUARANTEE POPUP
      if (guarantee_popup_close_buttons && guarantee_popup_content) {
        guarantee_popup_close_buttons.forEach((item) => {
          item.addEventListener("click", () => {
            guarantee_popup_content.classList.add("hidden");
          });
        });
      }

      // RESET PAGE DATA AFTER ADD TO CART
      function resetPageData() {
        selected_colors_array.length = 0;     

        for (const color of selected_colors_last_step) {
          color.removeAttribute("data-id");
          color.querySelector("img").removeAttribute("src");
          color.querySelector("img").classList.add("hidden");
          color.querySelector(".lock-icon").classList.remove("hidden");
          color.querySelector(".remove-selected-color-on-last-step").classList.add("hidden");
        }

        for (const color of nail_picker_selected_colors) {
          const default_title = color.dataset.defaultTitle;

          const image = color.querySelector("img");
          image.removeAttribute("src");
          image.classList.add("hidden");

          color.removeAttribute("data-id");

          color.querySelector("p").textContent = default_title;
          color.querySelector("span").classList.remove("hidden");
          color.querySelector(".remove-selected-color").classList.add("hidden");
        }

        for (const color of color_list_selected_colors) {
          const image = color.querySelector("img");
          image.removeAttribute("src");
          image.classList.add("hidden");

          color.removeAttribute("data-id");

          color.querySelector("span").classList.remove("hidden");
        }

        for (const color of selected_colors_sticky_atc) {
          const image = color.querySelector("img");
          image.removeAttribute("src");
          image.classList.add("hidden");

          color.removeAttribute("data-id");

          color.querySelector("span").classList.remove("hidden");
        }

        color_items.forEach(color_item => {
          const color_item_count = color_item.querySelector('.color-item-count');
          if (color_item_count) {
            color_item_count.textContent = 0;
          }
    
          const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper');
          if (quantity_color_item_wrapper) {
            quantity_color_item_wrapper.classList.add('hidden');
          }
    
          const add_color_item_button = color_item.querySelector('.add-color-item-button');
          if (add_color_item_button) {
            add_color_item_button.classList.remove('hidden');
          }
    
          const current_color_img = color_item.querySelector('.nail-picker-color-image-wrapper');
          current_color_img.classList.remove('selected-color-item');
        });

        variant_picker_items[pre_selected_variant_number - 1].click();
      }

      // ====================================================================================

      // LAST STEP POPUP ADD TO CART BUTTON
      // const nail_picker_last_step_atc_button = document.querySelector('.nail-picker-last-step-atc-button');
      // nail_picker_last_step_atc_button.addEventListener('click', () => {
      //   goToUpsells();
      // });

      // UPSSELLS OPEN / CLOSE BUTTONS
      const upsells_close_button = document.getElementById("upsells-close-button");
      const upsells_savings_amount = document.getElementById('upsells-savings-amount');
      const upsells_wrapper = document.getElementById("upsells-wrapper");

      let build_box_price = 0;
      let build_box_compare_price = 0;

      let upsells_products_prices = 0;
      let upsells_products_compare_prices = 0;

      const upsells_checkout_button = document.getElementById("upsells-checkout-button");
      const upsells_checkout_button_price = upsells_checkout_button.querySelector(".price");
      const upsells_checkout_button_compare_price = upsells_checkout_button.querySelector(".compare-price");

      const upsells_total_gifts = document.getElementById('upsells-total-gifts');
      if (upsells_total_gifts) {
        upsells_total_gifts.textContent = build_a_box_gift_items.length.toString();
      }

      let upsells_products_array = [];
      const upsells_add_buttons = document.querySelectorAll(".upsells-add-button");
      const upsells_quantity_buttons = document.querySelectorAll(".upsells-quantity-buttons");
      const remove_upsells_colors = document.querySelectorAll(".remove-upsells-color");
      const upsells_color_item_count_plus = document.querySelectorAll(".upsells-color-item-count-plus");

      function goToUpsells() {
        upsells_wrapper.classList.remove("hidden");

        upsells_products_array = [];
        upsells_products_prices = 0;
        upsells_products_compare_prices = 0;

        upsells_quantity_buttons.forEach((button) => {
          button.classList.add("hidden");
        });

        upsells_add_buttons.forEach((button) => {
          button.classList.remove("hidden");
        });

        const selected_selling_plan_discount = bab_percent_discount;
        /*let selected_selling_plan_discount;
        selling_plans_ids.forEach((plan) => {
          if (plan.id === selected_selling_plan_id) {
            selected_selling_plan_discount = plan.discount;
          }
        });*/

        const per_set_price = Math.round(
          ((product_price - (product_price * selected_selling_plan_discount) / 100) / 100) * 100
        );

        build_box_price = per_set_price * selected_colors_array.length;
        build_box_compare_price = parseFloat(product_price) * selected_colors_array.length;

        upsells_savings_amount.textContent = ((build_box_compare_price - build_box_price) / 100).toFixed(2);
        upsells_checkout_button_price.textContent = (build_box_price / 100 + upsells_products_prices / 100).toFixed(2);
        upsells_checkout_button_compare_price.textContent = (
          build_box_compare_price / 100 +
          upsells_products_compare_prices / 100
        ).toFixed(2);
      }

      upsells_close_button.addEventListener("click", () => {
        upsells_wrapper.classList.add("hidden");
      });

      // UPSSELLS ADD BUTTON
      upsells_add_buttons.forEach((button) => {
        button.addEventListener("click", (event) => {
          const current_button = event.currentTarget;
          const data_variant_id = current_button.dataset.variantId;
          const data_price = parseInt(current_button.dataset.price);
          const data_compare_price = parseInt(current_button.dataset.comparePrice);

          upsells_products_array.push(data_variant_id);
          upsells_products_prices += data_price;
          upsells_products_compare_prices += data_compare_price;

          const total_price = build_box_price / 100 + upsells_products_prices / 100;
          const total_compare_price = build_box_compare_price / 100 + upsells_products_compare_prices / 100;
          
          upsells_checkout_button_price.textContent = total_price.toFixed(2);
          upsells_checkout_button_compare_price.textContent = total_compare_price.toFixed(2);
          upsells_savings_amount.textContent = (total_compare_price - total_price).toFixed(2);

          current_button.classList.add("hidden");
          const next_upsells_quantity_button = current_button.nextElementSibling;
          next_upsells_quantity_button.classList.remove("hidden");
          next_upsells_quantity_button.classList.add("flex");

          const quntity = next_upsells_quantity_button.querySelector(".upsells-color-item-count");
          quntity.textContent = 1;
        });
      });

      function getUpsellProductCount(data_variant_id) {
        return upsells_products_array.filter((id) => id === data_variant_id).length;
      }

      remove_upsells_colors.forEach((button) => {
        button.addEventListener("click", (event) => {
          const current_button = event.currentTarget;
          const data_variant_id = current_button.dataset.variantId;
          const data_price = parseInt(current_button.dataset.price);
          const data_compare_price = parseInt(current_button.dataset.comparePrice);

          upsells_products_array.splice(upsells_products_array.indexOf(data_variant_id), 1);
          upsells_products_prices -= data_price;
          upsells_products_compare_prices -= data_compare_price;

          const total_price = build_box_price / 100 + upsells_products_prices / 100;
          const total_compare_price = build_box_compare_price / 100 + upsells_products_compare_prices / 100;
          
          upsells_checkout_button_price.textContent = total_price.toFixed(2);
          upsells_checkout_button_compare_price.textContent = total_compare_price.toFixed(2);
          upsells_savings_amount.textContent = (total_compare_price - total_price).toFixed(2);

          const quntity = getUpsellProductCount(data_variant_id);
          const quantity_element = current_button.nextElementSibling;
          quantity_element.textContent = quntity;

          if (quntity === 0) {
            const quantity_wrapper = current_button.parentElement;
            quantity_wrapper.classList.add("hidden");
            const next_upsells_quantity_button = quantity_wrapper.previousElementSibling;
            next_upsells_quantity_button.classList.remove("hidden");
            next_upsells_quantity_button.classList.add("flex");
          }
        });
      });

      upsells_color_item_count_plus.forEach((button) => {
        button.addEventListener("click", (event) => {
          const current_button = event.currentTarget;
          const data_variant_id = current_button.dataset.variantId;
          const data_price = parseInt(current_button.dataset.price);
          const data_compare_price = parseInt(current_button.dataset.comparePrice);

          upsells_products_array.push(data_variant_id);
          upsells_products_prices += data_price;
          upsells_products_compare_prices += data_compare_price;

          const total_price = build_box_price / 100 + upsells_products_prices / 100;
          const total_compare_price = build_box_compare_price / 100 + upsells_products_compare_prices / 100;
          
          upsells_checkout_button_price.textContent = total_price.toFixed(2);
          upsells_checkout_button_compare_price.textContent = total_compare_price.toFixed(2);
          upsells_savings_amount.textContent = (total_compare_price - total_price).toFixed(2);

          const quntity = getUpsellProductCount(data_variant_id);
          const quantity_element = current_button.previousElementSibling;
          quantity_element.textContent = quntity;
        });
      });

      // PEDICURE UPSELLS OPEN BUTTON
      const open_pedicure_upsells_button = document.getElementById("open-pedicure-upsells-button");
      const pedicure_upsells_wrapper = document.getElementById("pedicure-upsells-wrapper");
      const pedicure_product_cards = document.querySelectorAll(".pedicure-product-card");

      open_pedicure_upsells_button.addEventListener("click", () => {
        pedicure_upsells_wrapper.classList.remove("hidden");

        const selected_colors_names = [];
        nail_picker_selected_colors.forEach((color) => {
          const is_selected = color.dataset.id;
          if (is_selected) {
            const color_name = color.querySelector('p');
            selected_colors_names.push(color_name.textContent.trim());
          }
        });

        const unique_selected_colors_names = [...new Set(selected_colors_names)];

        pedicure_product_cards.forEach((card) => {
          const product_title = card.dataset.productTitle;
          card.classList.add("hidden");

          unique_selected_colors_names.forEach((name) => {
            if (product_title.includes(name)) {
              card.classList.remove("hidden");
            }
          });
        });
      });

      // PEDICURE UPSELLS CLOSE BUTTON
      const pedicure_upsells_close_buttons = document.querySelectorAll(".pedicure-upsells-close-button");
      pedicure_upsells_close_buttons.forEach((button) => {
        button.addEventListener("click", () => {
          pedicure_upsells_wrapper.classList.add("hidden");
        });
      });

      // UPSSELLS CHECKOUT BUTTON
      upsells_checkout_button.addEventListener("click", () => {
        const text = upsells_checkout_button.querySelector(".text");
        const loader = upsells_checkout_button.querySelector(".loader");
        const error_message = upsells_checkout_button.querySelector(".error-message");

        text.classList.add("hidden");
        loader.classList.remove("hidden");

        fetch("/cart.js")
          .then((res) => res.json())
          .then((data) => {
            let dynamicBoxIndex = 0;
            const cartItems = data.items;

            cartItems.forEach((item) => {
              if (item.properties._dynamicBoxIndex !== undefined) {
                dynamicBoxIndex = Math.max(dynamicBoxIndex, +item.properties._dynamicBoxIndex + 1);
              }
            });

            const gift_products_ids = [];
            const gift_products_handles = [];
            build_a_box_gift_items.forEach((item, i) => {
              const img = item.querySelector("img");
              const handle = item.dataset.handle;
              const id = item.dataset.id;

              if (!img.classList.contains("hidden") && i !== 0 && handle !== "none") {
                gift_products_ids.push(id);
                gift_products_handles.push(handle);
              }
            });

            const productCount = {};

            selected_colors_array.forEach((id) => {
              if (productCount[id]) {
                productCount[id]++;
              } else {
                productCount[id] = 1;
              }
            });

            const payload = {
              items: [
                ...selected_colors_array.map((id, i) => ({
                  id: id,
                  quantity: 1,
                  ...(selected_selling_plan_id && {
                    selling_plan: selected_selling_plan_id,
                  }),
                  properties: {
                    _dynamicBoxIndex: dynamicBoxIndex,
                    _dynamicBoxId: build_a_box_id,
                    ...(gift_products_handles.length > 0 && {
                      _gift_products_handles: gift_products_handles.join(","),
                    }),
                  },
                })),
                ...upsells_products_array.map((id) => ({
                  id: id,
                  quantity: 1,
                  properties: {
                    Upsell: "✓",
                  },
                })),
                ...gift_products_ids.map((id) => ({
                  id: id,
                  quantity: 1,
                  properties: {
                    Gift: "✓",
                  },
                })),
              ],
            };

            fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload),
            })
              .then((res) => res.json())
              .then((data) => {
                console.log("✅ Response from cart/add.js:", data);            

                if (data.items) {
                  console.log("✅ Products added to cart");                  

                  document.body.style.overflow = "auto";
                  hidden_overlay.classList.add("hidden");
                  nail_picker_last_step_popup.classList.add('hidden');
                  nail_picker_color_list_wrapper.classList.add("hidden");
                  upsells_wrapper.classList.add("hidden");

                  //onOpenDrawer();
                  //updateCartDrawer();
                  resetPageData();

                  text.classList.remove("hidden");
                  loader.classList.add("hidden");

                  window.location.href = "/checkout";
                } else {
                  console.log("❌ Products not added to cart");
                  error_message.classList.remove("hidden");
                  loader.classList.add("hidden");

                  setTimeout(() => {
                    error_message.classList.add("hidden");
                    text.classList.remove("hidden");
                  }, 5000);
                }
              })
              .catch((err) => console.error("❌ Error adding to cart:", err));            
          })
          .catch((err) => console.error("❌ Error adding to cart:", err));
      });
    })
    .catch((error) => console.error("Error:", error));
});
